import { addDays, isWeekend } from 'date-fns';

export const calculateEndDate = (startDate, plannedHours) => {
  // Check if plannedHours is 0 or null
  if (plannedHours === 0 || plannedHours == null) {
    return startDate;
  }

  let tempDate = new Date(startDate);
  let remainingHours = plannedHours;

  while (remainingHours > 0) {
    if (!isWeekend(tempDate)) { // Skip weekends
      remainingHours -= 8; // Subtract 8 hours for a full workday
    }
    tempDate = addDays(tempDate, 1);
  }

  return addDays(tempDate, -1); // Subtract 1 day to get the correct end date
};
